import { defineContent } from './defineContent.js';
import data from './explainer.json';
import { explainerSchema } from './explainer.schema.js';

export const explainer = defineContent(explainerSchema, data);
